// extracted by mini-css-extract-plugin
export default {"auditActivityIconContainer":"activity_icon-module___auditActivityIconContainer___c69583ce","auditActivityIconBadge":"activity_icon-module___auditActivityIconBadge___a85f89d1"};